








































import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import { TipoDePagamento } from '@/models'
import { FormaDePagamentoSugerida } from '@/models/pre-venda/PreVenda'
import { formatarMoeda } from '@/shareds/formatadores'
import { obterSomaTotalDaTaxaPorItem } from '@/shareds/venda-shareds'

const FORMAS_FORA_DA_VENDA = ['Consignado', 'Demonstração', 'Brinde']

@Component
export default class SeletorDeFormaDePagamentoDaPreVenda extends Vue {
	@Prop({ type: Object, default: null }) value!: FormaDePagamentoSugerida | null
	@Prop({ type: Array, default: () => [] }) tiposDePagamento!: TipoDePagamento[]
	@Prop({ type: Number, default: 0 }) valorTotal!: number
	@Prop({ type: Boolean, default: false }) disabled!: boolean
	@Ref() seletorDeParcelas?: any

	get tiposDisponiveis(): TipoDePagamento[] {
		return this.tiposDePagamento
			.filter(tipo => !tipo.inativo)
			.filter(tipo => !tipo.transacoes || tipo.transacoes.includes('Venda'))
			.filter(tipo => !FORMAS_FORA_DA_VENDA.includes(tipo.formaDePagamento))
			.sort((a, b) => {
				const oa = Number(a.ordem)
				const ob = Number(b.ordem)
				const aValida = Number.isFinite(oa) && oa >= 1
				const bValida = Number.isFinite(ob) && ob >= 1
				if (aValida && !bValida) return -1
				if (!aValida && bValida) return 1
				if (aValida && bValida && oa !== ob) return oa - ob
				return String(a.nome || '').localeCompare(String(b.nome || ''))
			})
	}

	get tipoSelecionado(): TipoDePagamento | null {
		if (!this.value) return null
		return this.tiposDePagamento.find(tipo => tipo.id === this.value?.tipoDePagamentoId) || null
	}

	get possuiParcelamento() {
		return !!this.tipoSelecionado?.parcelasComTaxas?.length
	}

	get parcelas(): number[] {
		return (this.tipoSelecionado?.parcelasComTaxas || [])
			.map(parcela => parcela.parcelamentos)
			.sort((a, b) => a - b)
	}

	selecionarTipo(tipoDePagamentoId: string | null) {
		const tipo = this.tiposDePagamento.find(t => t.id === tipoDePagamentoId)
		if (!tipo) {
			this.$emit('input', null)
			return
		}
		const temParcelas = !!tipo.parcelasComTaxas?.length
		this.$emit('input', {
			tipoDePagamentoId: tipo.id,
			nome: tipo.nome,
			qtdeDeParcelas: null,
		})
		if (!temParcelas) return
		setTimeout(() => {
			if (!this.seletorDeParcelas) return
			this.seletorDeParcelas.focus()
			this.seletorDeParcelas.isMenuActive = true
		}, 170)
	}

	selecionarParcelas(qtdeDeParcelas: number) {
		if (!this.value) return
		this.$emit('input', { ...this.value, qtdeDeParcelas })
	}

	descreverParcela(qtdeParcelas: number) {
		const valor = Number(this.valorTotal) || 0
		const parcelasComTaxas = this.tipoSelecionado?.parcelasComTaxas || []
		const valorDaTaxa = obterSomaTotalDaTaxaPorItem(valor, parcelasComTaxas, qtdeParcelas)
		if (valorDaTaxa > 0) {
			const parcelaComTaxas = parcelasComTaxas.find(parcela => parcela.parcelamentos === qtdeParcelas)
			const valorTotal = valor + valorDaTaxa
			return `R$ ${formatarMoeda(valorTotal / qtdeParcelas)} - R$ ${formatarMoeda(valorTotal)} (${parcelaComTaxas?.taxas}%)`
		}
		const valorDaParcela = qtdeParcelas > 0 ? valor / qtdeParcelas : valor
		return `R$ ${formatarMoeda(valorDaParcela)} - R$ ${formatarMoeda(valor)} (Sem Taxa)`
	}
}
